import React from "react";
import { KpiGrid, KpiGroup } from "../styles";
import StatCard from "./StatCard";
import colors from "../../../styles/colors";
import {
  DayPagesByStatus,
  Overview,
  SubscriptionStats,
} from "../../../types/Statistics2";
import { useTranslation } from "react-i18next";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";

interface Props {
  overview: Overview;
  subscriptionStats: SubscriptionStats;
  pagesByDay: DayPagesByStatus[];
}

const KpiSection: React.FC<Props> = ({
  overview,
  subscriptionStats,
  pagesByDay,
}) => {
  const { t } = useTranslation();

  const successPages = pagesByDay.reduce((acc, d) => acc + (d.success || 0), 0);
  const failedPages = pagesByDay.reduce(
    (acc, d) => acc + (d.failed || 0) + (d.exception || 0) + (d.calc_error || 0),
    0,
  );

  const cards = [
    {
      title: t("MONTHLY_QUOTA") || "Monthly Quota",
      value: (subscriptionStats?.totalMonthlyQuota || 0).toLocaleString(),
      icon: <AutoStoriesOutlinedIcon fontSize="medium" />,
      color: colors.theme.yaelGreen,
    },
    {
      title: t("USED_QUOTA") || "Used Quota",
      value: (subscriptionStats?.totalUsedQuota || 0).toLocaleString(),
      icon: <DescriptionOutlinedIcon fontSize="medium" />,
      color: colors.theme.yaelOrange,
    },
    {
      title: t("SUCCESS_RATE") || "Success Rate",
      value: `${overview?.successRate || 0}%`,
      icon: <TaskAltOutlinedIcon fontSize="medium" />,
      color: colors.theme.yaelGreen,
      subtitle: (
        <>
          <span style={{ color: colors.theme.yaelGreen, fontWeight: 700 }}>
            {successPages.toLocaleString()}
          </span>
          <span>{t("PAGES_SUCCESS")}</span>
          <span style={{ opacity: 0.5 }}>/</span>
          <span style={{ color: colors.theme.yaelOrange, fontWeight: 700 }}>
            {failedPages.toLocaleString()}
          </span>
          <span>{t("PAGES_FAILED")}</span>
        </>
      ),
    },
  ];

  return (
    <KpiGrid>
      <KpiGroup>
        {cards.map((card) => (
          <StatCard key={card.title} {...card} />
        ))}
      </KpiGroup>
    </KpiGrid>
  );
};

export default KpiSection;
